import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Dictionary } from '../../../domain/dictionary.model';
import { DictionaryService } from '../service/dictionary.service';

export namespace DictionaryAction {
    export class Download {
        static readonly type = 'DictionaryAction.Download';

        constructor(public codes: string[]) {
        }
    }
}

export class DictionaryStateModel {
    dictionaries: { [key: string]: Dictionary };
}

@State<DictionaryStateModel>({
    name: 'dictionaries',
    defaults: {
        dictionaries: {}
    }
})
@Injectable()
export class DictionaryState {
    constructor(private dictionaryService: DictionaryService) {
    }

    @Selector()
    static getDictionaries(state: DictionaryStateModel) {
        return state.dictionaries;
    }

    @Action(DictionaryAction.Download)
    downloadDictionaries(context: StateContext<DictionaryStateModel>, action: DictionaryAction.Download) {
        const state = context.getState().dictionaries;
        const keys = Object.keys(state);
        const codes = action.codes.filter(code => keys.indexOf(code) === -1);
        if (codes.length === 0) {
            return of(state);
        }
        return this.dictionaryService.download(codes)
            .pipe(map(result => {
                const dictionaries = {};
                Object.keys(state).forEach(key => dictionaries[key] = state[key]);
                result.forEach(dictionary => dictionaries[dictionary.code] = dictionary);
                context.patchState({dictionaries});
                return result;
            }));
    }
}
